var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 1.875C0.629883 1.875 0 2.50488 0 3.28125C0 3.72363 0.208008 4.13965 0.5625 4.40625L6.9375 9.1875C7.27148 9.43652 7.72852 9.43652 8.0625 9.1875L14.4375 4.40625C14.792 4.13965 15 3.72363 15 3.28125C15 2.50488 14.3701 1.875 13.5938 1.875H1.40625ZM0 5.15625V11.25C0 12.2842 0.84082 13.125 1.875 13.125H13.125C14.1592 13.125 15 12.2842 15 11.25V5.15625L8.625 9.9375C7.95703 10.4385 7.04297 10.4385 6.375 9.9375L0 5.15625Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSolidIcon);
export default __webpack_public_path__ + "static/media/envelope-solid-icon.e6fda47caf4283b8fb2d4912f2babcb7.svg";
export { ForwardRef as ReactComponent };